import { ViewModel, ObservableArray, DelegatedObservableArrayChangeListenner, View } from "binder";
import { TransactionTypeEnumProvider } from "src/erp/arap/payableReceivablesList/payableReceivablesList-viewModel";
import { PaginationInfo } from "../paginator/paginator-viewModel";
import { ColumnViewModel } from "./column/column-viewModel";
import { BooleanColumnViewModel, DateColumnViewModel, EnumColumnViewModel, NumericColumnViewModel, StringColumnViewModel } from "./column/columnTypes/columnTypes-viewModel";
import { IColumnVisitor } from "./column/columnVisitor";
import { BooleanFilterViewModel } from "./columnFilter/booleanFilter/booleanFilter-viewModel";
import { DateFilterViewModel } from "./columnFilter/dateFilter/dateFilter-viewModel";
import { EnumFilterViewModel } from "./columnFilter/enumFilter/enumFilter-viewModel";
import { NumericFilterViewModel } from "./columnFilter/numericFilter/numericFilter-viewModel";
import { StringFilterViewModel } from "./columnFilter/stringFilter/stringFilter-viewModel";
import { ExTableViewModel } from "./exTable-viewModel";
import { Converters } from "src/uicomponents/converters";
import { DateToString, ExcelExporter, stringIsNullOrEmpty, translate } from "src/common/utilities";
import { GetWindowNameMessage, RequestShowingPdfMessage, WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { arrayBufferToBase64, downloadFile } from "../utilities";
import { LocalNotification } from "src/server/localNotification";
import { ServerConnection } from "src/server/serverConnection";
import moment, { isMoment } from "moment";
// import { Stimulsoft } from "types/stimulsoft.reports";
declare var Stimulsoft: any;
declare var currentSystemLanguage;

export class ClientFilteringTable extends ExTableViewModel {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.filteredItems = ObservableArray.create<ViewModel>();
        this.items = ObservableArray.create<ViewModel>();
    }
    private _changeListenner: DelegatedObservableArrayChangeListenner;
    public set items(v: ObservableArray<ViewModel>) {
        if (this._items != null) {
            this._items.removeChangeListenner(this._changeListenner)
        }
        this._items = v;
        if (this._items != null) {
            let listenner = new DelegatedObservableArrayChangeListenner(this, x => this.sourceChanged());
            this._items.addChangeListenner(listenner);
            this.sourceChanged();
        }
    } public get items(): ObservableArray<ViewModel> { return this._items; } private _items: ObservableArray<ViewModel>;
    public set filteredItems(v: ObservableArray<ViewModel>) { this._filteredItems = v; } public get filteredItems(): ObservableArray<ViewModel> { return this._filteredItems; } private _filteredItems: ObservableArray<ViewModel>;

    sourceChanged() {
        this.filterChanged();
    }
    applyFullSearch() {
    }

    filterChanged() {
        var checker = new ClientSideFilteringExpressionBuilder();
        this.columns.forEach(x => x.accept(checker, null));
        this.filteredItems.update(...this.items.filter(x => checker.checkObject(x)));
        this.sortChanged();
    }

    sortChanged() {
        let sorter = new ClientSideSorter();
        let sortingColumns = this.columns.filter(x => x.columnSort.noSort == false);
        if (sortingColumns.length > 0) {
            sorter.sort(this.filteredItems, sortingColumns[0]);
        }

        this.informPageChange(this.paginator.currentPage, this.paginator.pageSize);
    }
    informPageChange(pageNo: number, pageSize: number): Promise<PaginationInfo> {
        let maxPageNo = Math.ceil(this.filteredItems.length / pageSize);
        if (pageNo > maxPageNo) {
            pageNo = maxPageNo;
        } else if (pageNo < 1) {
            pageNo = 1;
        }
        this.showingitems.update(...this.filteredItems.slice((pageNo - 1) * pageSize, (pageNo) * pageSize));
        let paginationInfo = new PaginationInfo(pageNo, maxPageNo);
        let result = Promise.resolve(paginationInfo);
        this.updatePaginationInfo(paginationInfo);
        this.paginator.updatePaginationInfo(pageNo, maxPageNo);
        this.onPageChanged();
        return result;
    }
    async setReportVariables(report, json) {
        let r = report;
        let properties = Object.getOwnPropertyNames(json);
        let variables = [...r.dictionary.variables.list];
        variables.forEach(x => {
            if (x.category != "ApadanaStatic") {
                r.dictionary.variables.remove(x);
            }
        });
        // r.dictionary.variables.clear();
        properties.forEach(x => {
            let v = new Stimulsoft.Report.Dictionary.StiVariable("Apadana", x, x);
            v.setValueProp(json[x]);
            r.dictionary.variables.add(v)
        })
    }

    async setReportVariablesValues(report, json) {
        let r = report;
        let properties = Object.getOwnPropertyNames(json);
        properties.forEach(x => {
            let v = new Stimulsoft.Report.Dictionary.StiVariable("Apadana", x, x,);
            v.setValueProp(json[x]);
            r.dictionary.variables.setByName(x, v);
        });
    }
    async exportExcel() {
        Stimulsoft.Base.StiLicense.Key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkgpgFGkUl79uxVs8X+uspx6K+tqdtOB5G1S6PFPRrlVNvMUiSiNYl724EZbrUAWwAYHlGLRbvxMviMExTh2l9xZJ2xc4K1z3ZVudRpQpuDdFq+fe0wKXSKlB6okl0hUd2ikQHfyzsAN8fJltqvGRa5LI8BFkA/f7tffwK6jzW5xYYhHxQpU3hy4fmKo/BSg6yKAoUq3yMZTG6tWeKnWcI6ftCDxEHd30EjMISNn1LCdLN0/4YmedTjM7x+0dMiI2Qif/yI+y8gmdbostOE8S2ZjrpKsgxVv2AAZPdzHEkzYSzx81RHDzZBhKRZc5mwWAmXsWBFRQol9PdSQ8BZYLqvJ4Jzrcrext+t1ZD7HE1RZPLPAqErO9eo+7Zn9Cvu5O73+b9dxhE2sRyAv9Tl1lV2WqMezWRsO55Q3LntawkPq0HvBkd9f8uVuq9zk7VKegetCDLb0wszBAs1mjWzN+ACVHiPVKIk94/QlCkj31dWCg8YTrT5btsKcLibxog7pv1+2e4yocZKWsposmcJbgG0";

        let data = new DataExtractor().GetData(this.filteredItems, this);
        let name = await this.handleMessage(new GetWindowNameMessage());
        let reportStructure = await this.generateReportStructure(data.Root, data.source);
        // var report = new Stimulsoft.Report.StiReport();
        // report.load(reportStructure);

        // report.regData("BusinessObject","BusinessObject",data.source)
        // this.setReportVariablesValues(report,data.Root);
        data.Root.BusinessObject = data.source;
        let toSendData = data.Root;

        let reportId = this.reportfileid;
        let result = await ServerConnection.callServer('/Complex/ReportServices/PrintReportFromClientSideData', {
            ReportId: reportId,
            Data: JSON.stringify(toSendData),
            ExportExcel: true
        });
        let b64 = result.PdfFile;
        downloadFile(b64, `${name}.xlsx`);

        // this.handleMessage(msg);

        // report.regData("SharedData",'SharedData',data.Root);

        // await report.renderAsync2();
        // let result = report.exportDocument(Stimulsoft.Report.StiExportFormat.Excel2007,new Stimulsoft.Report.Export.StiExcel2007ExportService() );
        // let b64 = arrayBufferToBase64(result);
        // let b64 = result.PdfFile;
        // downloadFile(b64,`${name}.xlsx`);

        // let data = this.extractData();
        // let name = await this.handleMessage(new GetWindowNameMessage());
        // let realData = data.data.map(row=>{
        //     let obj = {};
        //     data.columnTitles.forEach((x,i)=>{
        //         obj[x]=row[`_${i}`];
        //     })
        //     return obj;
        // })
        // new ExcelExporter().export(`${name}.xlsx`,realData);
    }
    async takeInPdf() {
        Stimulsoft.Base.StiLicense.Key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkgpgFGkUl79uxVs8X+uspx6K+tqdtOB5G1S6PFPRrlVNvMUiSiNYl724EZbrUAWwAYHlGLRbvxMviMExTh2l9xZJ2xc4K1z3ZVudRpQpuDdFq+fe0wKXSKlB6okl0hUd2ikQHfyzsAN8fJltqvGRa5LI8BFkA/f7tffwK6jzW5xYYhHxQpU3hy4fmKo/BSg6yKAoUq3yMZTG6tWeKnWcI6ftCDxEHd30EjMISNn1LCdLN0/4YmedTjM7x+0dMiI2Qif/yI+y8gmdbostOE8S2ZjrpKsgxVv2AAZPdzHEkzYSzx81RHDzZBhKRZc5mwWAmXsWBFRQol9PdSQ8BZYLqvJ4Jzrcrext+t1ZD7HE1RZPLPAqErO9eo+7Zn9Cvu5O73+b9dxhE2sRyAv9Tl1lV2WqMezWRsO55Q3LntawkPq0HvBkd9f8uVuq9zk7VKegetCDLb0wszBAs1mjWzN+ACVHiPVKIk94/QlCkj31dWCg8YTrT5btsKcLibxog7pv1+2e4yocZKWsposmcJbgG0";

        let data = new DataExtractor().GetData(this.filteredItems, this);
        let reportStructure = await this.generateReportStructure(data.Root, data.source);
        data.Root.BusinessObject = data.source;
        let toSendData = data.Root;

        let reportId = this.reportfileid;
        let result = await ServerConnection.callServer('/Complex/ReportServices/PrintReportFromClientSideData', {
            ReportId: reportId,
            Data: JSON.stringify(toSendData),
            ExportExcel: false
        });
        let b64 = result.PdfFile;
        return b64;

        // var report = new Stimulsoft.Report.StiReport();
        // report.load(reportStructure);

        // report.regData("BusinessObject","BusinessObject",data.source)
        // this.setReportVariablesValues(report,data.Root);

        // // report.regData("SharedData",'SharedData',data.Root);

        // await report.renderAsync2();
        // let result = report.exportDocument(Stimulsoft.Report.StiExportFormat.Pdf,new Stimulsoft.Report.Export.StiPdfExportService() );
        // let b64 = arrayBufferToBase64(result);
    }
    async exportPdf() {
        let b64 = await this.takeInPdf();
        let name = await this.handleMessage(new GetWindowNameMessage());
        downloadFile(b64, `${name}.pdf`);
    }

    async print() {

        let b64 = await this.takeInPdf();
        let req = new RequestShowingPdfMessage();
        req.pdf = b64;
        this.handleMessage(req);
        // let data = this.extractData();
        // let name = await this.handleMessage(new GetWindowNameMessage());
        // let reportContent =await this.generateReportStructure(data);
        // let pdfFile = await this.render(reportContent,data);
        // await LocalNotification.sendPdfPrint(pdfFile);

    }
    private async render(reportFile: string, data: ExportDataStructure): Promise<string> {
        Stimulsoft.Base.StiLicense.Key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHkgpgFGkUl79uxVs8X+uspx6K+tqdtOB5G1S6PFPRrlVNvMUiSiNYl724EZbrUAWwAYHlGLRbvxMviMExTh2l9xZJ2xc4K1z3ZVudRpQpuDdFq+fe0wKXSKlB6okl0hUd2ikQHfyzsAN8fJltqvGRa5LI8BFkA/f7tffwK6jzW5xYYhHxQpU3hy4fmKo/BSg6yKAoUq3yMZTG6tWeKnWcI6ftCDxEHd30EjMISNn1LCdLN0/4YmedTjM7x+0dMiI2Qif/yI+y8gmdbostOE8S2ZjrpKsgxVv2AAZPdzHEkzYSzx81RHDzZBhKRZc5mwWAmXsWBFRQol9PdSQ8BZYLqvJ4Jzrcrext+t1ZD7HE1RZPLPAqErO9eo+7Zn9Cvu5O73+b9dxhE2sRyAv9Tl1lV2WqMezWRsO55Q3LntawkPq0HvBkd9f8uVuq9zk7VKegetCDLb0wszBAs1mjWzN+ACVHiPVKIk94/QlCkj31dWCg8YTrT5btsKcLibxog7pv1+2e4yocZKWsposmcJbgG0";

        var report = new Stimulsoft.Report.StiReport();
        report.load(reportFile);
        report.regData('Dataset', 'Dataset', this.getDataForPdf(data));
        await report.renderAsync2();

        let result = report.exportDocument(Stimulsoft.Report.StiExportFormat.Pdf, new Stimulsoft.Report.Export.StiPdfExportService);
        let b64 = arrayBufferToBase64(result);
        return b64;
    }

    private getDataForPdf(data: ExportDataStructure) {
        let resultList = data.data.map(x => {
            let result = {};
            for (let i = 0; i < data.columnPropertyNames.length; i++) {
                result[`${data.columnPropertyNames[i]}`] = x[`_${i}`];
            }
            return result;
        })
        return resultList;
    }
    private async generateReportStructure(root: any, data: any): Promise<string> {
        var report = new Stimulsoft.Report.StiReport();

        let result = await ServerConnection.callServer('/Complex/ReportServices/GetReportFile', {
            Id: this.reportfileid,
            AsText: true
        });
        let reportContent = ''
        if (result.Exists == true) {
            reportContent = result.TextContent;
            report.load(reportContent);
        }


        report.regData("BusinessObject", "BusinessObject", data);
        this.setReportVariables(report, root);
        // report.regData("SharedData",'SharedData',root);
        report.dictionary.synchronize();
        //await report.renderAsync2()
        let jsonFile = report.saveToJsonString();
        if (jsonFile != reportContent) {
            if (result.Exists == true) {
                await ServerConnection.callServer('/Complex/ReportServices/UpdateReportFile', {
                    Id: this.reportfileid,
                    Name: null,
                    Path: null,
                    IsReportFileUpdated: true,
                    IsReportFileStructureChanged: false,
                    ContentAsText: jsonFile,
                    ReportFileStructure: '',
                    Engine: 1
                })
            } else {
                let name = prompt("report name : ");
                await ServerConnection.callServer('/Complex/ReportServices/CreateNewReport', {
                    PreferredId: this.reportfileid,
                    Name: name,
                    Path: '',
                    ContentAsText: jsonFile,
                    ReportFileStructure: '',
                    Engine: 1
                })
            }
        }
        return jsonFile;
    }
    private extractData(): ExportDataStructure {
        class ValueExtractor implements IColumnVisitor {
            visitBooleanColumn(column: BooleanColumnViewModel, parameter: any) {
                if (parameter == null) {
                    return '';
                } else if (parameter === true) {
                    return translate("clientFilteringTable.yes", {});
                } else {
                    return translate("clientFilteringTable.no", {});
                }
            }
            visitDateColumn(column: DateColumnViewModel, parameter: any) {
                if (parameter == null)
                    return '';
                else
                    return new Converters().persianDateConverter(parameter);
            }
            visitEnumColumn(column: EnumColumnViewModel, parameter: any) {
                return column.enumprovider.translateValue(parameter);
            }
            visitNumericColumn(column: NumericColumnViewModel, parameter: any) {
                if (parameter == null)
                    return '';
                return parameter.toString();
            }
            visitStringColumn(column: StringColumnViewModel, parameter: any) {
                if (parameter == null)
                    return '';
                return parameter;
            }
        }
        let visitor = new ValueExtractor();

        let data = this.filteredItems.map(row => {
            let obj = {};
            this.columns.forEach((c, i) => {
                let rawData = row[c.fieldname];
                let parsedData = c.accept(visitor, rawData);
                obj[`_${i}`] = parsedData;
            });
            return obj;
        });

        let result = new ExportDataStructure();
        result.data = data;
        result.columnTitles = this.columns.map(x => x.name);
        result.columnPropertyNames = this.columns.map(x => x.fieldname);
        return result;
    }
}
class ExportDataStructure {
    public columnPropertyNames: string[];
    public columnTitles: string[];
    public data: any[];
}
class ClientSideSorter implements IColumnVisitor {
    sort(filteredItems: ObservableArray<ViewModel>, column: ColumnViewModel) {
        let compareFunction = column.accept(this, null);
        if (column.columnSort.ascending)
            filteredItems.sort(compareFunction);
        else
            filteredItems.sort(function (x, y) {
                return -compareFunction(x, y);
            });
    }
    visitBooleanColumn(column: BooleanColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function (x, y) {
            if (x[fieldName] == y[fieldName]) {
                return 0;
            } else if (x[fieldName] == null) {
                return -1;
            } else if (y[fieldName] == null) {
                return 1;
            } else if (x[fieldName] == true) {
                return 1;
            } else {
                return -1;
            }
        }
    }
    visitDateColumn(column: DateColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function (x, y) {
            if (x[fieldName] == y[fieldName]) {
                return 0;
            } else if (x[fieldName] == null) {
                return -1;
            } else if (y[fieldName] == null) {
                return 1;
            } else {
                return (<moment.Moment>x[fieldName]).valueOf() - (<moment.Moment>y[fieldName]).valueOf()
            }
        }
    }
    visitEnumColumn(column: EnumColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function (x, y) {
            let xfield: string = null;
            let yfield: string = null;
            if (x[fieldName] != null)
                xfield = column.enumprovider.translateValue(x[fieldName]);
            if (y[fieldName] != null)
                yfield = column.enumprovider.translateValue(y[fieldName]);
            if (xfield == yfield) {
                return 0;
            } else if (xfield == null) {
                return -1;
            } else if (yfield == null) {
                return 1;
            } else {
                return (xfield).localeCompare(yfield);
            }
        }
    }
    visitNumericColumn(column: NumericColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function (x, y) {
            if (x[fieldName] == y[fieldName]) {
                return 0;
            } else if (x[fieldName] == null) {
                return -1;
            } else if (y[fieldName] == null) {
                return 1;
            } else {
                return x[fieldName] - y[fieldName];
            }
        }
    }
    visitStringColumn(column: StringColumnViewModel, parameter: any) {
        let fieldName = column.fieldname;
        return function (x, y) {
            if (x[fieldName] == y[fieldName]) {
                return 0;
            } else if (x[fieldName] == null) {
                return -1;
            } else if (y[fieldName] == null) {
                return 1;
            } else {
                return (<string>x[fieldName]).localeCompare(<string>y[fieldName]);
            }
        }
    }

}

class ClientSideFilteringExpressionBuilder implements IColumnVisitor {
    private expressions: any[] = [];
    visitBooleanColumn(column: BooleanColumnViewModel, parameter: any) {
        if (column.filter.isActive) {
            let value = (<BooleanFilterViewModel>column.filter).value;
            let fieldName = column.fieldname;
            this.expressions.push(function (param: any): boolean {
                return param[fieldName] == value
            });
        }
    }
    visitDateColumn(column: DateColumnViewModel, parameter: any) {
        if (column.filter.isActive) {
            let filter = (<DateFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let largerThan = filter.largerThan;
            let smallerThan = filter.smallerThan;
            if (filter.applySmaller && filter.applylarger) {
                this.expressions.push(function (param: any): boolean {
                    if (param[fieldName] == null)
                        return false;
                    else
                        return (<moment.Moment>param[fieldName]).isSameOrAfter(largerThan) && (<moment.Moment>param[fieldName]).isSameOrBefore(smallerThan);
                });
            } else if (filter.applylarger) {
                this.expressions.push(function (param: any): boolean {
                    if (param[fieldName] == null)
                        return false;
                    else
                        return (<moment.Moment>param[fieldName]).isSameOrAfter(largerThan);
                });
            } else if (filter.applySmaller) {
                this.expressions.push(function (param: any): boolean {
                    if (param[fieldName] == null)
                        return false;
                    else
                        return (<moment.Moment>param[fieldName]).isSameOrBefore(smallerThan);
                });
            }
        }
    }
    visitEnumColumn(column: EnumColumnViewModel, parameter: any) {
        if (column.filter.isActive) {
            let filter = (<EnumFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let values = new Set(filter.enumValues.filter(x => x.isSelected).map(x => x.value));
            this.expressions.push(function (param: any): boolean {
                if (param[fieldName] == null)
                    return true;
                else
                    return values.has(param[fieldName]);
            });
        }
    }
    visitNumericColumn(column: NumericColumnViewModel, parameter: any) {
        if (column.filter.isActive) {
            let filter = (<NumericFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            let largerThan = filter.largerThan;
            let smallerThan = filter.smallerThan;
            if(filter.enumFilters && filter.enumFilters.filter(x=>x.isSelected).length>0){
                let selectedFilters = filter.enumFilters.filter(x=>x.isSelected);
                this.expressions.push(function(param):boolean{
                    if(param[fieldName]==null)
                        return false;
                    else{
                        let value = param[fieldName];
                        let result = selectedFilters.map(x=>{
                            if(x.minValue>x.maxValue){
                                return value>=x.minValue || value<=x.maxValue;
                            }else{
                                return value>=x.minValue && value<=x.maxValue;
                            }
                        })
                        if(result.filter(x=>x==true).length>0){
                            return true;
                        }
                        return false;
                    }
                    
                });
                return;
            }
            if (filter.applySmaller && filter.applylarger) {
                this.expressions.push(function (param: any): boolean {
                    if (param[fieldName] == null)
                        return false;
                    else
                        return param[fieldName] >= largerThan && param[fieldName] <= smallerThan;
                });
            } else if (filter.applylarger) {
                this.expressions.push(function (param: any): boolean {
                    if (param[fieldName] == null)
                        return false;
                    else
                        return param[fieldName] >= largerThan;
                });
            } else if (filter.applySmaller) {
                this.expressions.push(function (param: any): boolean {
                    if (param[fieldName] == null)
                        return false;
                    else
                        return param[fieldName] <= smallerThan;
                });
            }
        }
    }
    visitStringColumn(column: StringColumnViewModel, parameter: any) {
        if (column.filter.isActive) {
            let filter = (<StringFilterViewModel>column.filter);
            let fieldName = column.fieldname;
            if(filter.shallUseTables==false){
                let value = filter.containsValue;
                if(value!=null && value.trim()!=''){
                    this.expressions.push(function(param:any):boolean{
                        if(param[fieldName]==null)
                            return false;
                        else
                            return param[fieldName].indexOf(value)>-1;
                    });
                }
            }else{
                let values = filter.searchValues.map(x=>x.value);
                if(values.length>0){
                    if(filter.isExclude){
                        this.expressions.push(function(param:any):boolean{
                            if(param[fieldName]==null)
                                return true;
                            else
                                return values.includes(param[fieldName])==false;
                        })
                    }else{
                        this.expressions.push(function(param:any):boolean{
                            if(param[fieldName]==null)
                                return false;
                            else
                                return values.includes(param[fieldName]);
                        })    
                    }
                }
            }
        }
    }
    checkObject(p: any): boolean {
        for (let i = 0; i < this.expressions.length; i++) {
            if (this.expressions[i](p) == false)
                return false;
        }
        return true;
    }
}


class Relation {
    public viewModel: ViewModel;
    public objectId: number;
    public properties: Map<string, any> = new Map<string, any>();
    public propertyViewModels: Map<string, number> = new Map<string, number>();
    public propertyListsViewModels: Map<string, number[]> = new Map<string, number[]>();
    public finalObj: any = {};
}
class DataExtractor {
    private invalidPropertiesAndMethods: Set<string>;

    constructor() {
        let dummy = new DummyViewModel(null);
        this.invalidPropertiesAndMethods = new Set<string>();
        let items = []
        items.push(...this.getAllEntries(dummy));
        items.forEach(x => this.invalidPropertiesAndMethods.add(x));
    }

    private flatten(data) {
        var result = {};
        var set = new Set<{ from: any, to: any, prop: string }>();
        function recurse(cur, prop) {
            if (cur != null && set.has({ from: cur, to: cur[prop], prop: prop })) {
                return;
            } else {
                if (cur != null) {
                    set.add({ from: cur, to: cur[prop], prop: prop });
                }
            }
            if (Object(cur) !== cur) {
                result[prop] = cur;
            } else if (Array.isArray(cur)) {
                for (var i = 0, l = cur.length; i < l; i++)
                    recurse(cur[i], prop + "[" + i + "]");
                if (l == 0)
                    result[prop] = [];
            } else {
                var isEmpty = true;
                for (var p in cur) {
                    isEmpty = false;
                    recurse(cur[p], prop ? prop+"_"+p : p);
                }
                if (isEmpty && prop)
                    result[prop] = {};
            }
        }
        recurse(data, "");
        return result;
    }
    public GetData(items: ViewModel[], table: ClientFilteringTable): { Root: any, source: any } {

        let root = this.getRootViewModel(table);
        let parentRelations = this.getQueueOfObjects(root, items, false);
        let parents = []; parentRelations.forEach(x => parents.push(x.viewModel));
        let listRelations = items.map(x => this.getQueueOfObjects(x, parents, true))

        let allRelations: Map<number, Relation> = new Map<number, Relation>();
        parentRelations.forEach(x => allRelations.set(x.objectId, x));
        listRelations.forEach(y =>
            y.forEach(x => allRelations.set(x.objectId, x))
        );

        allRelations.forEach(x => {
            x.properties.forEach((v, k) => x.finalObj[k] = v);
        });

        allRelations.forEach(x => {
            x.propertyViewModels.forEach((v, k) => {
                let r = allRelations.get(v);
                if (x.finalObj != r.finalObj) {
                    x.finalObj[k] = r == null ? null : r.finalObj;
                }
            })
        });
        allRelations.forEach(x => {
            x.propertyListsViewModels.forEach((v, k) => {
                x.finalObj[k] = v.map(q => {
                    let r = allRelations.get(q);
                    return r == null ? null : r.finalObj;
                }).filter(x => x != null);
            })
        });
        allRelations.forEach(x => x.finalObj.viewModel = null);
        return {
            Root: this.flatten(allRelations.get(root.viewModelObjectId).finalObj),
            source: {
                data: items.map(x => this.flatten(allRelations.get(x.viewModelObjectId).finalObj))
            }
        };
    }
    getRootViewModel(table: ClientFilteringTable) {
        let root: ViewModel = table;
        while (root && root instanceof WindowViewModel == false) {
            root = root.parentViewModel;
        }
        return root;
    }

    getQueueOfObjects(vm: ViewModel, ignoreList: ViewModel[], containList: boolean): Map<number, Relation> {
        let converter = new Converters();
        let ignoreIds = new Set(ignoreList.map(x => x.viewModelObjectId));
        let result: Map<number, Relation> = new Map<number, Relation>();

        var q: ViewModel[] = [];

        q.push(vm);
        while (q.length > 0) {
            let e = q.shift();
            if (ignoreIds.has(e.viewModelObjectId) == false) {
                ignoreIds.add(e.viewModelObjectId);
                let rel = new Relation();
                rel.viewModel = e;
                rel.objectId = e.viewModelObjectId;
                let entries = this.getAllEntries(e);
                entries.forEach(en => {
                    let value = e[en];
                    if (value == null || value == undefined) {

                    }
                    else if (value instanceof ViewModel) {
                        q.push(value);
                        rel.propertyViewModels.set(en, value.viewModelObjectId);
                    } else if (value instanceof Array && containList == true) {
                        // q.push(...value);
                        // rel.propertyListsViewModels.set(en,value.map(x=>x['viewModelObjectId']).filter(x=>x!=null));
                    } else if (isMoment(value)) {
                        rel.properties.set(en, DateToString(value,currentSystemLanguage,'YYYY/MM/DD HH:mm:ss dddd',true));
                    } else if (typeof (value) == 'string' || typeof (value) == 'number' || typeof (value) == 'boolean') {
                        rel.properties.set(en, value);
                    }
                });
                result.set(e.viewModelObjectId, rel);
            }
        }
        return result;
    }

    private getAllEntries(obj: any): Set<string> {
        let result: any[] = [];
        let o = obj;
        while ((o = Object.getPrototypeOf(o))) {
            let names = Object.getOwnPropertyNames(o);
            let desc = Object.getOwnPropertyDescriptors(o);
            let map = names.map(x => [x, desc[x]]);
            result.push(...map.filter(x => x[1]['value'] === undefined && (<any>x[0]).startsWith('__') == false && this.invalidPropertiesAndMethods.has(<any>x[0]) == false))
        }
        return new Set(result.map(x => x[0]));
    }
}


class DummyViewModel extends ViewModel {
    public getTypeId(): string {
        throw new Error("Method not implemented.");
    }
    public GetDefaultView(): View<ViewModel> {
        throw new Error("Method not implemented.");
    }
}